import { FormError } from '@heathmont/moon-components';
import { rem } from '@heathmont/moon-utils';
import useLanguage from '~/client/hooks/useLanguage';
import useSite from '~/client/hooks/useSite';
import Translate from '~/client/shared/i18n/Translate';
import InlineStack from '~/client/shared/InlineStack';
import Stack from '~/client/shared/Stack';
import buildOptions from './helpers/buildOptions';
import useDateInput from './useDateInput';
import useUserGeoLocation from '../../FormPhoneNumber/hooks/useUserGeoLocation';
import CustomSelect from '../../FormSelect/CustomSelect';

type Props = {
  name: string;
  initial?: number;
  adultOnly?: boolean;
  error?: string;
  onChange?: (value?: Partial<DayMonthYear>) => void;
  onBlur?: () => void;
};

const DateInput: FC<Props> = (props) => {
  const {
    values,
    dayLabel,
    monthLabel,
    yearLabel,
    minYear,
    maxYear,
    handleChange,
  } = useDateInput(props);
  const { userGeoCountryCode } = useUserGeoLocation();
  const { isBitcasino } = useSite();
  const { code: language } = useLanguage();
  const isJP = userGeoCountryCode === 'JP' || language === 'ja';
  const isJPBitcasino = isJP && isBitcasino;

  const { error, onBlur } = props;

  type SelectType = 'day' | 'month' | 'year';

  const selectsOrder: SelectType[] = isJPBitcasino
    ? ['year', 'month', 'day']
    : ['day', 'month', 'year'];

  const selects = {
    day: (
      <CustomSelect
        name="day"
        label={dayLabel}
        defaultValue={values?.day ?? ''}
        onChange={handleChange('day')}
        onBlur={onBlur}
        fullWidth
        data-testid="day"
      >
        {buildOptions(1, 31)}
      </CustomSelect>
    ),
    month: (
      <CustomSelect
        name="month"
        label={monthLabel}
        defaultValue={values?.month ?? ''}
        onChange={handleChange('month')}
        onBlur={onBlur}
        fullWidth
        data-testid="month"
      >
        {buildOptions(1, 12)}
      </CustomSelect>
    ),
    year: (
      <CustomSelect
        name="year"
        label={yearLabel}
        defaultValue={values?.year ?? ''}
        onChange={handleChange('year')}
        onBlur={onBlur}
        fullWidth
        data-testid="year"
      >
        {buildOptions(minYear, maxYear, true)}
      </CustomSelect>
    ),
  };

  return (
    <Stack space="0">
      <InlineStack space="0" templateColumns="repeat(3, 1fr)" gridGap={rem(8)}>
        {selectsOrder.map((select) => selects[select])}
      </InlineStack>
      {!!error && (
        <FormError>
          <Translate id={error} />
        </FormError>
      )}
    </Stack>
  );
};

export default DateInput;
